import { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Link } from 'react-router-dom';
import { auth } from '../../../firebase';
import { CheckFill, ImageGame } from '../../../assets';
import { onBlur, ValidationState } from '../auth.props';
import { FeedbackMessage, IconSVG, Spin } from '../../../components';
import { ROUTES } from '../../../routes';

const RecoverPassword = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState<ValidationState>({});
  const [sent, setSent] = useState(false);

  const allOk =
    (email.length > 0 && !errors?.email && errors?.email !== undefined) ||
    loading;

  const handleRecover = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setLoading(true);
      await sendPasswordResetEmail(auth, email);
      setSent(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      setErrors({ ...errors, email: 'Ocurrió un error, inténtalo más tarde' });
      setSent(false);
      setLoading(false);
    }
  };

  return (
    <div className="isg-auth-page">
      <img
        src={ImageGame}
        alt="Imperial Stones Game"
        className="isg-auth-image-bg"
      />
      <div className="isg-auth-form-container">
        <h1>RECUPERAR CONTRASEÑA</h1>

        {sent ? (
          <div className="isg-auth-form-box">
            <p className="isg-auth-reset-sended">
              <IconSVG
                Icon={CheckFill}
                stroke="#00ff00"
                fill="#ffffff00"
                className="isg-auth-reset-sended-check"
              />{' '}
              Si el correo está registrado, recibirás un enlace para restablecer
              tu contraseña.
            </p>
          </div>
        ) : (
          <form className="isg-auth-form-box" onSubmit={handleRecover}>
            <input
              className="isg-input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={(e) => onBlur(e.target.value, 'email', setErrors)}
              required
            />
            {errors.email?.length ? (
              <FeedbackMessage message={errors.email} />
            ) : (
              <></>
            )}

            <button
              className={`isg-form-button ${!allOk ? 'disabled' : ''}`}
              type="submit"
              disabled={!allOk}
            >
              <Spin spin={loading} size={20} className="isg-spin-floating" />
              <p className={loading ? 'loading' : ''}>Enviar enlace</p>
            </button>
          </form>
        )}

        <div className="isg-auth-form-box divider">
          <p className="isg-auth-sininup-link">
            <Link to={ROUTES.SIGNIN} target="_top">
              Volver a iniciar sesión
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecoverPassword;
